<script>
export default { inheritAttrs: false };
</script>

<script setup>
import { computed, defineProps } from 'vue';
import Checkbox from '@/components/elements/checkbox/Checkbox.vue';

const props = defineProps({
	answers: {
		type: Array,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	response: {
		type: Array,
		required: false,
	},
	otherText: {
		type: String,
		required: false,
	},
});

const normalizeIndices = (response) => {
	if (!Array.isArray(response)) return [];
	return response.map((index) => Number(index));
};

const selectedOptions = computed(() => normalizeIndices(props.response));

const isSelected = (index) => selectedOptions.value.includes(Number(index));
</script>
<template>
	<div class="flex flex-col gap-2">
		<div v-for="(answer, index) in props.answers" :key="index">
			<div class="flex items-start gap-2">
				<div
					v-if="props.disabled"
					class="mt-0.5 flex-none shrink-0"
					:class="isSelected(index) ? 'text-yellow-500' : 'text-neutral-400'"
				>
					<svg
						v-if="isSelected(index)"
						fill="none"
						height="21"
						viewBox="0 0 20 20"
						width="20"
					>
						<path
							d="M7.5 9.16634L10 11.6663L18.3333 3.33301"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.66667"
						/>
						<path
							d="M17.5 10V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.66667"
						/>
					</svg>
					<svg
						v-else
						fill="none"
						height="21"
						viewBox="0 0 20 21"
						width="20"
					>
						<path
							d="M15.8333 3H4.16667C3.24619 3 2.5 3.74619 2.5 4.66667V16.3333C2.5 17.2538 3.24619 18 4.16667 18H15.8333C16.7538 18 17.5 17.2538 17.5 16.3333V4.66667C17.5 3.74619 16.7538 3 15.8333 3Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.66667"
						/>
					</svg>
				</div>
				<div v-else class="mt-0.5 flex-none shrink-0">
					<Checkbox :value="isSelected(index)" />
				</div>
				<div class="min-w-0 flex-1 break-words text-sm text-neutral-600">
					{{ answer }}
				</div>
			</div>
		</div>
		<div v-if="props.otherText" class="flex items-center p-4 bg-gray-50 rounded-lg">
			<div class="text-neutral-700 text-sm">{{ props.otherText }}</div>
		</div>
	</div>
</template>
